import { Button } from 'primereact/button';
import { Menubar } from 'primereact/menubar';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useEmployee } from '../context/employee';
import { useSocket } from '../context/socket';
import ParentCreate from './parent/create';

const codeVersion = '1.0.9';

export default function NavSite() {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const { appVersion, employee, SignOut } = useEmployee();
    const { connected } = useSocket();

    const [items, setItems] = useState([]);
    const [openCreate, setOpenCreate] = useState(false);

    const baseItems = useMemo(() => {
        return [
            {
                label: 'CFCE Online v' + codeVersion,
                className: connected ? 'logo-green' : 'logo-red',
                command: () => {
                    navigate('/');
                }
            }
        ];
    }, [navigate, connected]);

    const publicPaths = useMemo(() => {
        return ['/validate-token', '/sign-in'];
    }, []);

    const RefreshButton = () => {
        return (
            <Button
                label='Click for New Version'
                severity='danger'
                size="small"
                onClick={() => {
                    window.location.reload();
                }}
            />
        );
    };

    const MenuEndPublic = useCallback(() => {
        if (publicPaths.includes(pathname)) {
            return null;
        }

        return (
            <>
                {appVersion !== codeVersion ? <RefreshButton /> : null}

                <Button
                    rounded
                    text
                    title="Sign In"
                    size="small"
                    icon="pi pi-sign-in"
                    onClick={() => {
                        navigate('/sign-in');
                    }}
                />
            </>
        );
    }, [appVersion, pathname, navigate, publicPaths]);

    const MenuEndPrivate = useCallback(() => {
        return (
            <>
                {appVersion !== codeVersion ? <RefreshButton /> : null}

                <Button
                    rounded
                    label={employee?.name}
                    text
                    title="Sign Out"
                    size="small"
                    icon="pi pi-sign-out"
                    onClick={() => {
                        SignOut();
                    }}
                />
            </>
        );
    }, [appVersion, employee, SignOut]);

    useEffect(() => {
        const items_set = [...baseItems];

        if (!!employee) {
            items_set.push({
                label: 'Parents',
                items: [
                    {
                        label: 'List',
                        command: () => {
                            navigate('/parents');
                        }
                    },
                    {
                        label: 'Create',
                        command: () => {
                            setOpenCreate(true);
                        }
                    }
                ]
            });

            items_set.push({
                label: 'Programs',
                command: () => {
                    navigate('/programs');
                }
            });

            items_set.push({
                label: 'Services',
                items: [
                    {
                        label: 'Individual Services',
                        command: () => {
                            navigate('/services-individual');
                        }
                    },
                    {
                        label: 'Group Services',
                        command: () => {
                            navigate('/services-group');
                        }
                    },
                    {
                        label: 'Program Services',
                        command: () => {
                            navigate('/services-program');
                        }
                    }
                ]
            });

            if (employee.admin) {
                items_set.push({
                    label: 'Admin',
                    items: [
                        {
                            label: 'Reports',
                            command: () => {
                                navigate('/reports');
                            }
                        },
                        {
                            label: 'Employees',
                            command: () => {
                                navigate('/employees');
                            }
                        },
                        {
                            label: 'Lists',
                            command: () => {
                                navigate('/lists');
                            }
                        }
                    ]
                });
            }
        }

        setItems(items_set);
    }, [baseItems, employee, navigate]);

    if (!!employee) {
        return (
            <>
                <Menubar model={items} end={MenuEndPrivate} />

                {!openCreate ? null : (
                    <ParentCreate
                        open={openCreate}
                        onClose={() => {
                            setOpenCreate(false);
                        }}
                    />
                )}
            </>
        );
    }

    return (
        <>
            <Menubar model={items} end={MenuEndPublic} />

            {!openCreate ? null : (
                <ParentCreate
                    open={openCreate}
                    onClose={() => {
                        setOpenCreate(false);
                    }}
                />
            )}
        </>
    );
}
